<app-page-shell>
    <p-toast position="top-center"></p-toast>

    <app-page-hero
        eyebrow="Payment Runs"
        title="Payment Proposals"
        subtitle="Generate due-date based vendor payment proposals, review exclusions, approve release, create vouchers, and generate remittance advice.">
        <div actions>
            <p-button label="Refresh" icon="pi pi-refresh" [loading]="loading" (click)="load()"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-form-section title="Generate Proposal" subtitle="Eligible bills must be posted, approved, open, not held, not match-exception, and bank-ready. Unallocated vendor credits do not reduce these proposed payments; review them before paying.">
        <div class="form-grid">
            <label>Run date<p-datePicker [(ngModel)]="request.runDate" dateFormat="yy-mm-dd" appendTo="body"></p-datePicker></label>
            <label>Due by<p-datePicker [(ngModel)]="request.dueDateCutoff" dateFormat="yy-mm-dd" appendTo="body"></p-datePicker></label>
            <label>Currency<p-select [options]="currencyOptions" [(ngModel)]="request.currencyCode" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"></p-select></label>
            <label>Bank account ID<p-inputNumber [(ngModel)]="request.bankAccountId" [useGrouping]="false"></p-inputNumber></label>
            <label>Priority<p-select [options]="priorityOptions" [(ngModel)]="request.paymentPriority" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"></p-select></label>
            <label class="check"><p-checkbox [(ngModel)]="request.includePaymentHeld" [binary]="true"></p-checkbox> Include held bills</label>
        </div>
        <div class="section-actions">
            <p-button label="Generate Proposal" icon="pi pi-play" (click)="generate()"></p-button>
        </div>
    </app-page-form-section>

    <app-page-data-panel title="Proposal Search" [resultText]="proposals.length + ' proposals'">
        <div actions>
            <p-select [options]="statusOptions" [(ngModel)]="selectedStatus" optionLabel="label" optionValue="value" placeholder="Status" [showClear]="true" appendTo="body"></p-select>
            <p-button label="Apply" icon="pi pi-filter" [outlined]="true" (click)="load()"></p-button>
        </div>

        <p-table [value]="proposals" [loading]="loading" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Proposal</th>
                    <th>Status</th>
                    <th>Run Date</th>
                    <th>Due Cutoff</th>
                    <th>Currency</th>
                    <th class="numeric">Payable</th>
                    <th class="numeric">Credits</th>
                    <th class="numeric">Cash Payment</th>
                    <th class="actions">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row.proposalNumber || row.proposalId }}</td>
                    <td><p-tag [value]="row.status || 'DRAFT'" [severity]="statusSeverity(row.status)"></p-tag></td>
                    <td>{{ row.runDate | date:'yyyy-MM-dd' }}</td>
                    <td>{{ row.dueDateCutoff | date:'yyyy-MM-dd' }}</td>
                    <td>{{ row.currencyCode || 'SAR' }}</td>
                    <td class="numeric">{{ money(row.totalPayableAmount, row.currencyCode || 'SAR') }}</td>
                    <td class="numeric">{{ money(row.totalCreditApplied, row.currencyCode || 'SAR') }}</td>
                    <td class="numeric">{{ money(row.totalProposedPayment, row.currencyCode || 'SAR') }}</td>
                    <td class="actions">
                        <p-button label="View" icon="pi pi-external-link" size="small" [outlined]="true" (click)="open(row)"></p-button>
                        <p-button label="Approve" icon="pi pi-check" size="small" severity="success" [outlined]="true" (click)="approve(row)" *ngIf="row.status === 'DRAFT'"></p-button>
                        <p-button label="Release" icon="pi pi-send" size="small" severity="warn" [outlined]="true" (click)="release(row)" *ngIf="row.status === 'APPROVED'"></p-button>
                        <p-button label="Vouchers" icon="pi pi-wallet" size="small" severity="help" [outlined]="true" (click)="vouchers(row)" *ngIf="row.status === 'APPROVED' || row.status === 'RELEASED'"></p-button>
                        <p-button label="Remittance" icon="pi pi-envelope" size="small" severity="secondary" [outlined]="true" (click)="remittance(row)" *ngIf="row.status === 'VOUCHERS_GENERATED'"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="9">No payment proposals found.</td></tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
